import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constants} from '../constants';
import {DateHistoryModalComponent} from '../../shared/modal/date-history-modal/date-history-modal.component';

/**
 * A container's In Production delay history, newest first: one row per reschedule of its Add GPSM
 * Reference task, with the note given for it. The PHP API serves it as `delay_reasons` (the
 * stock-allocation cards), api-v2 as `delayReasons` (Container Management); the rows are the same.
 */
export function containerDelayHistory(container: any): any[] {
    return container?.delay_reasons ?? container?.delayReasons ?? [];
}

/**
 * Opens the history in the same read-only window as the SRD history, so the sales team reads it
 * the way they already read SRD changes: the task's date before and after each reschedule, when,
 * by whom, and why.
 */
export function openContainerDelayHistory(modalService: NgbModal, container: any): void {
    const instance = modalService.open(DateHistoryModalComponent, {
        windowClass: 'date-history-modal',
        backdrop: 'static',
        centered: false,
    });
    instance.componentInstance.title = Constants.PRODUCTION_DELAY_HISTORY_MODAL_TITLE;
    instance.componentInstance.rows = containerDelayHistory(container).map((row: any) => ({
        last_date: row.previous_scheduled_date,
        new_date: row.scheduled_date,
        updated_date: row.created_at,
        updated_by: [row.backend_user?.first_name, row.backend_user?.last_name].filter(Boolean).join(' '),
        notes: row.reason,
    }));
}
